import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
    selector: '[appFadeIn]',
    standalone: false
})
export class FadeInDirective implements OnInit {
	@Input() delay: number;

	constructor(private el: ElementRef) {
	}

	ngOnInit(): void {
		this.el.nativeElement.style.opacity = '0';
		this.el.nativeElement.style.visibility = 'hidden';
		this.el.nativeElement.style.top = '10px';
		this.el.nativeElement.style.transition = '.3s ease-in-out';
		setTimeout(() => {
			this.el.nativeElement.style.opacity = '1';
			this.el.nativeElement.style.visibility = 'visible';
			this.el.nativeElement.style.top = '0';
		}, this.delay ? this.delay : 300);
	}
}
